import allvacanciesbig from "../images/allvacanciesbig.svg";
import allvacanciessmall from "../images/allvacanciessmall.svg";

const Loading = () => {
    return (
        <div className="loading text-center">
            <img src={allvacanciessmall} className="smallloading" alt="" />
            <img src={allvacanciesbig} className="bigloading" alt="" />
        </div>
    );
};

export default Loading;
